import React from 'react';
import {
	Container,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	IconButton,
	Checkbox,
	TextField,
	Paper,
} from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CreateIcon from '@mui/icons-material/Create';
import CheckIcon from '@mui/icons-material/Check';

export const DraggableAreaList = ({
	checked,
	handleOnClickEdit,
	items,
	setItems,
	newDay,
	setNewDay,
	currentAreaItem,
	handleToggleArea,
	editing,
	printItems,
}) => {
	const handleOnDragEnd = (result) => {
		if (!result.destination) return;

		const updatedItems = Array.from(items);
		const [reorderedItem] = updatedItems.splice(result.source.index, 1);
		updatedItems.splice(result.destination.index, 0, reorderedItem);
		// setItems(handleSortAreasByIndexOrder(updatedItems));
		setItems(updatedItems);
		printItems(updatedItems);
	};

	// Handle case where there are no items
	if (!items.length) {
		return (
			<Container maxWidth='sm' style={{ marginTop: '20px' }}>
				<p>No areas available</p>
			</Container>
		);
	}

	return (
		<Container maxWidth='sm' style={{ marginTop: '20px' }}>
			<DragDropContext onDragEnd={handleOnDragEnd}>
				<Droppable droppableId='areas'>
					{(provided) => (
						<List
							{...provided.droppableProps}
							ref={provided.innerRef}
							sx={{
								width: '100%',
								bgcolor: 'background.paper',
							}}
						>
							{items.map((area, index) => {
								const labelId = `checkbox-list-label-${area.id}`;

								return (
									<Draggable
										key={area.id}
										draggableId={area.id.toString()}
										index={index}
									>
										{(provided) => (
											<ListItem
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												component={Paper}
												disablePadding
												style={{
													marginBottom: '8px',
													...provided.draggableProps
														.style,
												}}
											>
												<ListItemButton
													role={undefined}
													onClick={handleToggleArea(
														area.id
													)}
													dense
												>
													<ListItemIcon>
														<Checkbox
															edge='start'
															checked={
																checked.indexOf(
																	area.id
																) !== -1
															}
															tabIndex={-1}
															disableRipple
															inputProps={{
																'aria-labelledby':
																	labelId,
															}}
														/>
													</ListItemIcon>
													<ListItemText
														id={labelId}
														primary={`${
															index + 1
														}. ${area.name}`}
														style={{
															marginLeft: '-21px',
														}}
													/>
												</ListItemButton>

												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														justifyContent:
															'flex-end',
														alignItems: 'center',
														paddingRight: '16px',
													}}
												>
													{currentAreaItem ===
													area.id ? (
														<TextField
															autoFocus
															style={{
																width: '60px',
																margin: '0',
															}}
															variant='standard'
															value={newDay}
															onChange={({
																target,
															}) =>
																setNewDay(
																	target.value
																)
															}
															label='Días'
														/>
													) : (
														<p
															style={{
																margin: '8px 0 0 0',
															}}
														>
															Días: {area.days}
														</p>
													)}
													<IconButton
														style={{
															color: '#1976d2',
															marginLeft: '12px',
														}}
														edge='end'
														aria-label='edit'
														onClick={() =>
															handleOnClickEdit(
																area
															)
														}
													>
														{editing &&
														currentAreaItem ===
															area.id ? (
															<CheckIcon />
														) : (
															<CreateIcon />
														)}
													</IconButton>
												</div>
											</ListItem>
										)}
									</Draggable>
								);
							})}
							{provided.placeholder}
						</List>
					)}
				</Droppable>
			</DragDropContext>
		</Container>
	);
};
